export default __webpack_public_path__ + "static/media/gallery-3.bc7bba48.jpg";